
import { defineComponent, PropType, ref } from "vue";
import { useRouter } from "vue-router";
import { routeNames } from "@/router/index";
import Thumbnail, { ThumbnailItem } from "@/components/Thumbnail.vue";
import { ITemplateSet, twoBytwoOrder } from "@/services/Models";
import { toResourceUrl } from "@/lib/shared";
import { IEditData, isInvalidTemplate } from "@/services/Models";

export default defineComponent({
  name: "TemplateThumbnail",
  components: {
    Thumbnail,
  },
  props: {
    item: { require: true, type: Object as PropType<ITemplateSet> },
    isHideMoreLink: { type: Boolean },
    editData: { type: Object as PropType<IEditData> },
  },
  setup(props) {
    const router = useRouter();
    const isShowModal = ref(false);
    const isExistDescribe = props.item?.describe !== "";
    const showModal = () => {
      isShowModal.value = true;
    };

    // 編集画面へ遷移する
    const toEdit = () => {
      if (props.item === undefined) return;

      router.push({
        name: routeNames.EditTemplate,
        params: { templateID: props.item.id ?? 0 },
        query: { editID: props.editData?.id },
      });
      isShowModal.value = false;
    };
    const thumbnailItem = new ThumbnailItem({
      imgPath: toResourceUrl(props.item?.thumbnail ?? ""),
      clickAction: props.editData === undefined ? showModal : toEdit,
      // テンプレートなしはボタン非活性(編集画面に遷移させない)
      isDisabled: isInvalidTemplate(props.item),
    });

    const more = () => {
      const authorID = props.item?.frames.find(() => true)?.author?.id;
      // 選択した作者でテンプレートを絞り込む
      router.push({
        name: routeNames.SearchTemplate2,
        query: {
          authorID: authorID,
        },
        force: true,
      });
      isShowModal.value = false;
    };
    return {
      isShowModal,
      toEdit,
      thumbnailItem,
      twoBytwoOrder,
      toResourceUrl,
      more,
      isExistDescribe,
    };
  },
});
